import {PriceSummaryModel} from './PriceSummary.model';
import {ViolationModel} from './Violation.model';
import {AdditionalFeeModel} from './AdditionalFee.model';
import {MinimumOrderAmountModel} from './MinimumOrderAmount.model';
import {EstimateTotalsResponse} from '@wix/auto_sdk_ecom_current-cart';
import {CouponDiscountModel} from './CouponDiscount.model';
import {toAppliedCouponCartV1} from '../../utils/coupon';
import {ModelContext} from '../../../types/app.types';
import {CouponModel} from '../Cart/Coupon.model';
import {PaymentSummaryModel} from './PaymentSummary.model';
import {PriceModel} from '../Price.model';
import {DeliverySummaryModel} from './DeliverySummary.model';

export class CartSummaryModel {
  public additionalFees: AdditionalFeeModel[];
  public violations: ViolationModel[];
  public paymentSummary: PaymentSummaryModel;
  public priceSummary: PriceSummaryModel;
  public deliverySummary: DeliverySummaryModel;
  public couponDiscount: CouponDiscountModel;
  public minimumOrderAmount: MinimumOrderAmountModel;
  public estimatedAmountToPay: number;
  /**
   * @deprecated
   */
  public appliedCoupon: CouponModel;

  constructor(params: CartSummaryModel) {
    this.additionalFees = params.additionalFees;
    this.violations = params.violations;
    this.paymentSummary = params.paymentSummary;
    this.priceSummary = params.priceSummary;
    this.deliverySummary = params.deliverySummary;
    this.couponDiscount = params.couponDiscount;
    this.minimumOrderAmount = params.minimumOrderAmount;
    this.estimatedAmountToPay = params.estimatedAmountToPay;
    this.appliedCoupon = params.appliedCoupon;
  }

  public static fromCartV1(estimatedTotals: EstimateTotalsResponse, modelContext: ModelContext): CartSummaryModel {
    return new CartSummaryModel({
      additionalFees: (estimatedTotals?.additionalFees ?? []).map((fee) =>
        AdditionalFeeModel.fromCartV1(fee, modelContext)
      ),
      violations: (estimatedTotals?.violations ?? []).map(ViolationModel.fromCartV1),
      estimatedAmountToPay: Number(
        modelContext.shouldPayWithConvertedCurrency
          ? estimatedTotals.priceSummary.total.convertedAmount
          : estimatedTotals.priceSummary.total.amount
      ),
      paymentSummary: PaymentSummaryModel.fromCartV1({
        payNow: PriceModel.fromCartV1(estimatedTotals.payNow.total, modelContext),
        payLater: PriceModel.fromCartV1(estimatedTotals.payLater.total, modelContext),
        payAfterFreeTrial: PriceModel.fromCartV1(estimatedTotals.payAfterFreeTrial.total, modelContext),
      }),
      priceSummary: PriceSummaryModel.fromCartV1(estimatedTotals.priceSummary, modelContext),
      deliverySummary: DeliverySummaryModel.fromCartV1(estimatedTotals.shippingInfo?.selectedCarrierServiceOption),
      couponDiscount: CouponDiscountModel.fromCartV1(estimatedTotals.appliedDiscounts, modelContext),
      minimumOrderAmount: MinimumOrderAmountModel.fromCartV1(
        estimatedTotals.calculationErrors.orderValidationErrors,
        modelContext
      ),
      appliedCoupon: toAppliedCouponCartV1(estimatedTotals.appliedDiscounts, modelContext),
    });
  }
}
